/**
 * Sport-specific hero background images.
 * Each image is chosen to match a specific visual for that sport:
 *   Baseball       → home plate with batter and catcher
 *   Soccer         → aerial view of a soccer pitch
 *   Volleyball     → volleyball(s) on a volleyball court
 *   Softball       → female pitcher in the act of pitching
 *   Football       → football team gear in a locker room
 *   Flag Football  → player running with flags on their waist
 *   Mixed Martial Arts → moody view of an MMA fighter through the octagon cage
 *   Lacrosse       → lacrosse player in full gear
 *   Ice Hockey     → top-down view of an ice hockey rink
 *   Gymnastics     → gymnast on a vault
 *   Swimming       → competitive swimming lane
 *   Cheer          → cheerleaders in formation
 *   Basketball     → basketball hoop (default)
 *
 * All images are Pexels free-license CDN URLs.
 * Falls back to Basketball for any unrecognized sport.
 */
export const SPORT_HERO_IMAGES = {
    Basketball: "https://images.pexels.com/photos/5549509/pexels-photo-5549509.jpeg?auto=compress&cs=tinysrgb&w=1600",
    Soccer: "https://images.pexels.com/photos/3448250/pexels-photo-3448250.jpeg?auto=compress&cs=tinysrgb&w=1600",
    Baseball: "https://images.pexels.com/photos/236985/pexels-photo-236985.jpeg?auto=compress&cs=tinysrgb&w=1600",
    Volleyball: "https://images.pexels.com/photos/30290766/pexels-photo-30290766.jpeg?auto=compress&cs=tinysrgb&w=1600",
    Softball: "https://images.pexels.com/photos/37907705/pexels-photo-37907705.jpeg?auto=compress&cs=tinysrgb&w=1600",
    Football: "https://images.pexels.com/photos/840908/pexels-photo-840908.jpeg?auto=compress&cs=tinysrgb&w=1600",
    "Flag Football": "https://images.pexels.com/photos/34956232/pexels-photo-34956232.jpeg?auto=compress&cs=tinysrgb&w=1600",
    "Mixed Martial Arts": "https://images.pexels.com/photos/28550403/pexels-photo-28550403.jpeg?auto=compress&cs=tinysrgb&w=1600",
    Lacrosse: "https://images.pexels.com/photos/38510553/pexels-photo-38510553.jpeg?auto=compress&cs=tinysrgb&w=1600",
    "Ice Hockey": "https://images.pexels.com/photos/6469035/pexels-photo-6469035.jpeg?auto=compress&cs=tinysrgb&w=1600",
    Gymnastics: "https://images.pexels.com/photos/6571937/pexels-photo-6571937.jpeg?auto=compress&cs=tinysrgb&w=1600",
    Swimming: "https://images.pexels.com/photos/863988/pexels-photo-863988.jpeg?auto=compress&cs=tinysrgb&w=1600",
    Cheer: "https://images.pexels.com/photos/7894382/pexels-photo-7894382.jpeg?auto=compress&cs=tinysrgb&w=1600",
};

export function heroForSport(sport) {
    return SPORT_HERO_IMAGES[sport] || SPORT_HERO_IMAGES.Basketball;
}
